import { useTranslation } from "react-i18next";
import ActionLinkButton from "../../../atoms/buttons/ActionLinkButton";
import Text from "../../../molecules/content/Text";
import SendAgainFlow from "../../../molecules/sendAgain/SendAgainFlow";
import OneTimePasswordForm from "../oneTimePassword/OneTimePasswordForm";
import Content from "../../../templates/wrapper/Content";

const VerificationForm = ({
  title,
  description,
  showRemoveOnDesktop,
  handleGetCode,
  handleResend,
  isPhoneNumberVerification,
  handleClickVerifyWithDifferentEmail,
  handleClose,
}) => {
  const { t } = useTranslation();

  return (
    <Content showRemoveOnDesktop={showRemoveOnDesktop} onClose={handleClose}>
      <div className="flex flex-col gap-8 text-center">
        <Text variant="h2" className="flex justify-center text-vestelColor">
          {title}
        </Text>
        <Text variant="small" className="text-center">
          {description}
        </Text>
        <OneTimePasswordForm onSubmit={handleGetCode} />
        <SendAgainFlow
          label={t("forgotPassword.resendCode")}
          resendFunction={handleResend}
        />
        <ActionLinkButton
          text={
            isPhoneNumberVerification
              ? t("forgotPassword.verifyWithDifferentPhone")
              : t("forgotPassword.verifyWithDifferentEmail")
          }
          handleClick={handleClickVerifyWithDifferentEmail}
        />
        {showRemoveOnDesktop && (
          <div className="confirm-code confirm-code-mb relative mt-[90px]">
            <div>
              <span onClick={handleClose}>{t("confirmAttribute.logout")}</span>
            </div>
          </div>
        )}
      </div>
    </Content>
  );
};

export default VerificationForm;
